// extracted by mini-css-extract-plugin
export default {"container":"Collapsible_container__q8s8G"};